module.exports = __webpack_public_path__ + "static/media/keeps_shampoo.0043e572.png";